import { render, staticRenderFns } from "./dingyue.vue?vue&type=template&id=8e851f24&"
import script from "./dingyue.vue?vue&type=script&lang=js&"
export * from "./dingyue.vue?vue&type=script&lang=js&"
import style0 from "./dingyue.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports